const receita = (DataBase, Datatype) => {
	const Receita = DataBase.new(
		{
			id_pedido: Datatype.STRING,
			id_cliente: Datatype.STRING,
			id_forma_pagamento: Datatype.STRING,
			status: Datatype.BOOLEAN,
			valor: Datatype.NUMBER,
			valor_pago: Datatype.NUMBER,
			dt_vencimento: Datatype.TIMESTAMP,
			dt_pagamento: Datatype.TIMESTAMP,
		},
		{
			tracked: true,
			dateLogs: true,
			softDelete: true,
			collection: "receita",
			model: "Receita",
		}
	);

	Receita.relate = (models) => [
		{
			model: models.Cliente,
			fk: "id_cliente",
			name: "cliente",
		},
		{
			model: models.FormaPagamento,
			fk: "id_forma_pagamento",
			name: "forma_pagamento",
		},
	];

	return Receita;
};

export default receita;
